oyc.Cards = {
  container: '.cards',
  item: '.cards details',
  attribute: 'open',
  isTabletMode: null,

  init: function () {
    this.container = $(this.container);
    if (this.container.length > 0) {

      this.toggleEvents();

      $(window).on('resize', this.debounce(() => {
        this.toggleEvents();
      }, 250));
    }
  },
  toggleEvents: function () {
    const isTablet = window.innerWidth >= 768;
    if (this.isTabletMode === isTablet) {
      return;
    }
    this.isTabletMode = isTablet;

    if (isTablet) {
      // Replace 'name' with 'data-name'
      $(this.item).each(function () {
        const name = $(this).attr('name');
        if (name) {
          $(this).attr('data-name', name).removeAttr('name');
        }
      });
      $(this.item).attr(this.attribute, true);

      $(this.item).on('click.prevent', 'summary', function (e) {
        e.preventDefault();
      });
    } else {
      // Restore 'name' from 'data-name'
      $(this.item).each(function () {
        const dataName = $(this).attr('data-name');
        if (dataName) {
          $(this).attr('name', dataName).removeAttr('data-name');
        }
      });
      $(this.item).off('click.prevent');
      $(this.item).removeAttr(this.attribute);
    }
  },

  debounce: function (func, delay) {
    let timer;
    return function (...args) {
      clearTimeout(timer);
      timer = setTimeout(() => func.apply(this, args), delay);
    };
  }
};
